import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "h-screen overflow-hidden" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = {
  key: 1,
  class: "rounded-[10px] bg-[#2B2C32] w-full"
}
const _hoisted_4 = { class: "text-[24px] text-white font-semibold px-4 pt-4" }
const _hoisted_5 = { class: "flex justify-between" }
const _hoisted_6 = { class: "table w-full mt-6 px-2 pb-4" }
const _hoisted_7 = {
  key: 0,
  class: "w-full large:px-4 pb-52"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_block_loading = _resolveComponent("block-loading")!
  const _component_table_lite = _resolveComponent("table-lite")!
  const _component_edit_security_role = _resolveComponent("edit-security-role")!
  const _component_add_security_role = _resolveComponent("add-security-role")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([(_ctx.edit || _ctx.add)?'large:grid-cols-2 small:grid-cols-1':'grid-cols-1', "grid auto-cols-auto p-4 bg-[#23242A] text-white h-screen overflow-y-auto"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.table.loading)
          ? (_openBlock(), _createBlock(_component_block_loading, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[2] || (_cache[2] = _createElementVNode("span", null, "Security Roles", -1)),
                  _createElementVNode("button", {
                    class: "text-white bg-theme-green hover:bg-green-600 py-1 h-10 px-1 text-2xl border-0 rounded-md cursor-pointer",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createSecurityRole && _ctx.createSecurityRole(...args)), ["prevent"]))
                  }, [...(_cache[1] || (_cache[1] = [
                    _createElementVNode("span", null, [
                      _createElementVNode("svg", {
                        fill: "currentColor",
                        width: "32",
                        height: "32",
                        viewBox: "0 0 24 24",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", { d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" })
                      ])
                    ], -1)
                  ]))])
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_table_lite, {
                  "is-loading": _ctx.table.loading,
                  "is-static-mode": true,
                  "is-hide-paging": true,
                  class: _normalizeClass('block w-full admin-table admin-table-custom'),
                  rowClasses: row => row?row.id.toString():null,
                  columns: _ctx.table.columns,
                  rows: _ctx.table.rows,
                  sortable: _ctx.table.sortable,
                  total: _ctx.table.rows.length,
                  onDoSearch: _ctx.doSearch,
                  onRowClicked: _ctx.selectedRow,
                  messages: {
                                gotoPageLabel: 'Go to page',
                                noDataAvailable: 'No records found!',
                            }
                }, null, 8, ["is-loading", "rowClasses", "columns", "rows", "sortable", "total", "onDoSearch", "onRowClicked"])
              ])
            ]))
      ]),
      (_ctx.edit || _ctx.add)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_ctx.edit)
              ? (_openBlock(), _createBlock(_component_edit_security_role, {
                  key: 0,
                  editItem: _ctx.editItem,
                  onEdited: _ctx.edited,
                  onClose: _ctx.closeEdit
                }, null, 8, ["editItem", "onEdited", "onClose"]))
              : _createCommentVNode("", true),
            (_ctx.add)
              ? (_openBlock(), _createBlock(_component_add_security_role, {
                  key: 1,
                  onAdded: _ctx.added,
                  onClose: _ctx.closeAdd
                }, null, 8, ["onAdded", "onClose"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}